/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {updateCurrentPaymentTerm} from "../../../../../../state/slices/account";
// material
import {ListTable, Tip, Link, Button, Title, Group, SingleSelectDropDown, Loader} from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './existingpayments_styles';

const paymenttypemap = {
  'CHECK': 'Check',
  'CHECKS': 'Check',
  'PAYPAL': 'PayPal',
  'ACH': 'Direct Deposit / ACH',
  'WIRE': 'Wire Transfer'
}

const paymentTerms = [
    {name: "Net 30", value: "Net30"},
    {name: "Net 45", value: "Net45"},
    {name: "Net 60", value: "Net60"},
]

/* ========== ~~~~~~~~~~ EXISTING PAYMENTS  ~~~~~~~~~~ ========== */
const ExistingPayments = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { paymentInfo, viewPaymentDetails, addPaymentMethod } = props
  const { mocked } = useSelector((state) => state.session);
  const { paymentTerm, companyInfoUpdateStatus }  = useSelector(state => state.account)

  const [currentTerm, setCurrentTerm] = useState(paymentTerm.current);

  const handleTableData = () => {
    let dataArray = [];
    // changed this from map to forEach since we're not technically mapping anything here
    paymentInfo.forEach((item, index) => {
        if(item.paymentType !== 'NONE') dataArray.push({
            method: paymenttypemap[item.paymentType],
            lastupdate: item.lastUpdate,
            preferred: `${item.preferredPayment ? 'Yes' : 'No'}`,
            edit: <div className={`editcolumn`}><Link type={`action`} text={`Details`} color={`primary`} icon={`eye`} action={() => viewPaymentDetails(item)} /></div>
        })
    });
    return dataArray;
  }

  return (
    <div className={`existingpayments ${props.classes.existingpayments}`}>
        {mocked && <Group name={'paymentterm'}>
            <Title>
                <h2>Payment term</h2>
                <p>This will indicate how often the publisher will be paid out for their portion of the
                    revenue
                    share.</p>
            </Title>
            {
                companyInfoUpdateStatus === 'pending' ? <Loader/> :
                    <SingleSelectDropDown
                        searchable={false}
                        onSelect={e => {
                            setCurrentTerm(e.value)
                            dispatch(updateCurrentPaymentTerm(e.value))
                        }}
                        items={paymentTerms}
                        selected={paymentTerms.find(term => term.value === currentTerm)}
                        name={currentTerm}
                    />
            }
        </Group>}
        <Title variant={'withctas'}>
              <h2>Payment Method </h2>
              <Group name={`controls`}>
                <Button name={'addpaymentbtn'} variant={'primary'} text={'Add Payment Method'} handleClick={addPaymentMethod} />
              </Group>
          </Title>

        <ListTable
            name={`paymentmethod`}
            type={`standard`}
            size={`full`}
            columnHeads={{
                method: 'Payment Method',
                lastupdate: 'Last Update',
                preferred: <span>Preferred <Tip space={`none`} content={<p>This is the method that COOL Media will use to pay you.</p>}/></span>,
                edit: ''
            }}
            data={handleTableData()}
            rowsPerPage={'general'}
            paginationLocation={`bottom`}
        />
    </div>
  )
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ExistingPayments